'use strict';

var chunkERLKLNQZ_js = require('./chunk-ERLKLNQZ.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var r=[1e3,6e4,36e5,864e5,6048e5,2592e6,31536e6,Number.MAX_SAFE_INTEGER];function b(a,i,u){let{units:s,now:f,before:o,after:m}=chunkERLKLNQZ_js.c({units:["\u79D2","\u5206\u949F","\u5C0F\u65F6","\u5929","\u5468","\u4E2A\u6708","\u5E74"],now:"\u521A\u521A",before:"{value}{unit}\u524D",after:"{value}{unit}\u540E"},u),p=typeof a=="number"?new Date(a).getTime():a.getTime(),g=(i instanceof Date?i:typeof i=="number"?new Date(i):new Date).getTime(),t=p-g,e=r.findIndex(n=>Math.abs(t)<n)-1;if(e<0&&(e=0),e>r.length-1&&(e=r.length-1),t<1e3&&t>-1e3)return f;if(t<=-1e3){let n=parseInt(String(Math.abs(t)/r[e]));return o.replace("{value}",n).replace("{unit}",s[e])}else {let n=parseInt(String(Math.abs(t)/r[e]));return m.replace("{value}",n).replace("{unit}",s[e])}}

exports.a = b;
